import React from 'react';
import styled from 'styled-components';
import { FaMapMarkedAlt, FaFilter, FaHeart, FaInfoCircle, FaChartBar, FaUsers, FaUser, FaSignOutAlt } from 'react-icons/fa';

const HeaderContainer = styled.header`
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  padding: 1rem 2rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
`;

const Logo = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 1.5rem;
  font-weight: bold;
`;

const NavItems = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
`;

const NavItem = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem 1rem;
  border-radius: 6px;
  cursor: pointer;
  transition: background-color 0.2s;
  
  &:hover {
    background-color: rgba(255,255,255,0.1);
  }
`;

const UserSection = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
`;

const UserInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  color: white;
  font-size: 0.9rem;
  cursor: pointer;
  padding: 0.5rem 1rem;
  border-radius: 6px;
  transition: background-color 0.2s;
  
  &:hover {
    background-color: rgba(255,255,255,0.1);
  }
`;

const LogoutButton = styled.button`
  background: rgba(255,255,255,0.1);
  color: white;
  border: none;
  border-radius: 6px;
  padding: 0.5rem 1rem;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.9rem;
  transition: background-color 0.2s;
  
  &:hover {
    background-color: rgba(255,255,255,0.2);
  }
`;

const Header = ({ onToggleParcelDetails, isParcelDetailsOpen, onToggleFavorites, isFavoritesOpen, onToggleFilter, isFilterOpen, onToggleDashboard, isDashboardOpen, onToggleUserManagement, isUserManagementOpen, onToggleUserProfile, isUserProfileOpen, user, onLogout }) => {
  return (
    <HeaderContainer>
      <Logo>
        <FaMapMarkedAlt />
        Parcel Filtering System
      </Logo>
      <NavItems>
        <NavItem onClick={onToggleFilter} style={isFilterOpen ? { backgroundColor: 'rgba(255,255,255,0.15)' } : {}}>
          <FaFilter style={{ color: isFilterOpen ? '#2563eb' : undefined }} />
          Filters
        </NavItem>
        <NavItem onClick={onToggleFavorites} style={isFavoritesOpen ? { backgroundColor: 'rgba(255,255,255,0.15)' } : {}}>
          <FaHeart style={{ color: isFavoritesOpen ? '#e11d48' : undefined }} />
          Favorites
        </NavItem>
        <NavItem onClick={onToggleParcelDetails} style={isParcelDetailsOpen ? { backgroundColor: 'rgba(255,255,255,0.15)' } : {}}>
          <FaInfoCircle style={{ color: isParcelDetailsOpen ? '#22c55e' : undefined }} />
          Details
        </NavItem>
        <NavItem onClick={onToggleDashboard} style={isDashboardOpen ? { backgroundColor: 'rgba(255,255,255,0.15)' } : {}}>
          <FaChartBar style={{ color: isDashboardOpen ? '#f59e0b' : undefined }} />
          Dashboard
        </NavItem>
        {user?.is_superuser && (
          <NavItem onClick={onToggleUserManagement} style={isUserManagementOpen ? { backgroundColor: 'rgba(255,255,255,0.15)' } : {}}>
            <FaUsers style={{ color: isUserManagementOpen ? '#dc3545' : undefined }} />
            Users
          </NavItem>
        )}
      </NavItems>
      
      <UserSection>
        <UserInfo 
          onClick={onToggleUserProfile}
          style={isUserProfileOpen ? { backgroundColor: 'rgba(255,255,255,0.15)' } : {}}
        >
          <FaUser style={{ color: isUserProfileOpen ? '#667eea' : undefined }} />
          {user?.full_name || user?.username}
        </UserInfo>
        <LogoutButton onClick={onLogout}>
          <FaSignOutAlt />
          Logout
        </LogoutButton>
      </UserSection>
    </HeaderContainer>
  );
};

export default Header; 